import { ComponentType, lazy } from 'react';

import { DEFAULT_RETRY_OPTIONS } from './retry-lazy-load.constant';
import { attemptLoadComponent } from './retry-lazy-load.service';
import { RetryOptions } from './retry-lazy-load.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const retryDynamicImport = <T extends ComponentType<any>>(
  importFunction: () => Promise<{ default: T }>,
  options: RetryOptions = {}
): React.LazyExoticComponent<T> => {
  const { maxRetryCount, retryDelayMs } = {
    ...DEFAULT_RETRY_OPTIONS,
    ...options,
  };

  return lazy(() =>
    attemptLoadComponent(importFunction, maxRetryCount, retryDelayMs)
  );
};
